import SimulatorSuperBowl from "../components/simulatorSuperBowl/simulatorSuperBowl.js";

export default function SimulatorSuperBowlPage() {

  return (
    <div className="simulator-superbowl-page">
      <SimulatorSuperBowl />
    </div>
  );
}